import { Dispatch, ExtraArgs, GetState } from '../../types'
import { fetchLoaderHelper } from '../redux/loader/thunksFor'
import { APIPolicy, DetailedAPI, DetailedPolicy } from '../../remote-api/models'
import selectorActionCreatorsFor from '../redux/selector/actionCreatorsFor'
import { SelectorAction } from '../redux/selector/model'
import { changePlatformToken, selectors as authSelectors } from '../../lifecycle/auth'
import { selectResourceFromResources } from '../redux/selector/thunksFor'
import { BasicSelectorOptions } from '../selector/model'

export const API_POLICY_RESOURCE_NAME = 'api-policy'
export const API_POLICY_PREFIX = 'MONITORING'

export type APIPolicyAction =
  | SelectorAction<DetailedPolicy>

// Basic Actions Creators

export const apiPolicyActionCreators = (origin?: string) => {
  return {
    ...selectorActionCreatorsFor<DetailedPolicy>(API_POLICY_RESOURCE_NAME, API_POLICY_PREFIX, origin)
  }
}

// Thunks

export const fetchAPIPolicies = (orgId: string, apiId: string, origin?: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  const apiIdNumber = Number(apiId)
  return fetchLoaderHelper<DetailedPolicy[]>(dispatch, apiPolicyActionCreators(origin), async () => {
    return api.ui(getState).fetchDetailedApis(orgId, [apiIdNumber], true).then((apis: DetailedAPI[]) => {
      let policies: DetailedPolicy[] = []
      apis.forEach(elem => {
        if (elem.policies) {
          policies = policies.concat(elem.policies)
        }
      })
      return policies
    })
  }).catch(() => [])
}

export const selectAPIPolicy = (policyId: string, policies: DetailedPolicy[], options: BasicSelectorOptions) =>
  (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs): DetailedPolicy | undefined => {
    const actionCreators = apiPolicyActionCreators(options.origin)

    return dispatch(selectResourceFromResources<DetailedPolicy>(
      API_POLICY_RESOURCE_NAME,
      policies,
      (policy: DetailedPolicy) => policy.id.toString(),
      actionCreators.resourceSelected,
      options.origin,
      options.lsOrigin,
      policyId
    ))
}
